<smallstack-markdown-editor [translation]="value()" (translationChange)="setValue($event)"></smallstack-markdown-editor>
